function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#272727;}\n\t.st1{fill:#4A4A4A;}\n\t.st2{fill:none;stroke:#3B3B3B;stroke-width:0.5;stroke-miterlimit:10;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M837.55,328.58c55.11-23.14,101.97-22.35,112.81-22.01c7.93,0.25,44.59,1.78,89.18,18.96 c24.81,9.56,72.48,28.59,111.65,76.13c44.28,53.73,51.5,112.08,54.81,142.1c3.11,28.17,8.27,74.98-13.2,126.88 c-37.42,90.45-126.04,124.53-147.18,131.95c-4.82,1.69-122.05,40.93-216.2-21.32c-31.55-20.86-53.17-48.26-63.95-61.92 c-33.73-42.75-48.21-82.77-52.78-96.43c-5.15-15.38-13.65-41.35-15.23-76.13c-1.08-23.67-4.03-89.29,39.59-147.18 C768.86,357.43,809.59,340.33,837.55,328.58z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("circle", {
  className: "st1",
  cx: 948.54,
  cy: 565.59,
  r: 211.63
});

var _ref5 =
/*#__PURE__*/
React.createElement("circle", {
  className: "st2",
  cx: 986.76,
  cy: 540.48,
  r: 538.01
});

var _ref6 =
/*#__PURE__*/
React.createElement("circle", {
  className: "st2",
  cx: 952.6,
  cy: 567.94,
  r: 289.79
});

var SvgCompaniesBg = function SvgCompaniesBg(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1920 1080",
    style: {
      enableBackground: "new 0 0 1920 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCompaniesBg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Companies-BG.161376d9.svg";
export { ForwardRef as ReactComponent };